<section class="hvac-account-admin-header">
    <hvac-content-header [data]="(accountAdminUtilsService.getAdminBreadCrumbData() | async ) || breadCrumbData"></hvac-content-header>
</section>

<section class="hvac-content-container hvac-account-admin-container">
    <router-outlet></router-outlet>
</section>
